/*
example of a full exhibition object:
{
    year: "2022 Exhibition Schedule",
    exhibition: "Solo booth 'Peoplescapes' The Other Art Fair, ",
    location: "The Barker Hangar, Santa Monica, CA USA",
    date: "22nd-25th September 2022",
    link: { theLink: "/bio", linkText: "Here is the Link" },
    linkOut: { theLink: "http://www.google.com", linkText: "Link to google" },
  }

  note that for a link out you must include the full url including http:// or https://
*/

const upcomingExhibitions = [
  {
    year: "2026 Exhibition Schedule",
      exhibition: "Group Show — UNO, Comber Street Studios",
      location: "5 Comber St, Paddington, Sydney AU",
      date: "18th–22nd November 2026",
  },
  {
      exhibition: "Group Show — 8 Wall Gallery",
      location: "1/8 Soudan Lane, Paddington, Sydney AU",
      date: "8th August–12th September 2026",
  },
  {
      exhibition: "Passport Capsule Collection",
      location: "Online — Worldwide shipping.",
      date: "Released 10th July 2026",
      link: { theLink: "/paintings/passport-capsule-2026", linkText: "View the collection." },
  },
  {     
    year: "2025 Exhibition Schedule",
      exhibition: "Solo booth — The Other Art Fair",
      location: "Dallas Market Hall, Dallas USA",
      date: "15th–18th May 2025",
  },
  {
    exhibition: "Solo show — TIME MACHINE",
    location: "50 Buckingham St, Surry Hills, Sydney AU",
    date: "4th–15th February 2025",
  }, 
  ];

export default upcomingExhibitions;
